import AntAvatar, { type AvatarProps as AntAvatarProps } from "antd/lib/avatar";
import { ComponentProps, FC } from "react";

export type AvatarProps = AntAvatarProps;
export type AvatarGroupProps = ComponentProps<typeof AntAvatar.Group>;

export const Avatar: FC<AvatarProps> = props => {
    return <AntAvatar {...props} />;
};

export const AvatarGroup: FC<AvatarGroupProps> = props => {
    return <AntAvatar.Group {...props} />;
};
